import { render, staticRenderFns } from "./LabelAddModal.vue?vue&type=template&id=411d99b0&scoped=true"
import script from "./LabelAddModal.vue?vue&type=script&lang=js"
export * from "./LabelAddModal.vue?vue&type=script&lang=js"
import style0 from "./LabelAddModal.vue?vue&type=style&index=0&id=411d99b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411d99b0",
  null
  
)

export default component.exports